import { Pipe, PipeTransform } from '@angular/core';
import type { BalanceReportMonthDataInterface } from '@zaoblako/shared/modules/finance/dtos/balance-report/balance-report-month-data.dto';

const balanceReportMonthDataNames: Record<keyof BalanceReportMonthDataInterface, string> = {
  factKassAmount: 'Факт. Касса',
  factSaleAmount: 'Факт. Начисления',
  planAmount: 'План',
  deltaKassAmount: 'Дельта. Касса',
  deltaSaleAmount: 'Дельта. Начисления'
};

@Pipe({
  standalone: true,
  name: 'balanceReportMonthDataName'
})
export class BalanceReportMonthDataNamePipe implements PipeTransform {
  public transform(key: keyof BalanceReportMonthDataInterface): string {
    return balanceReportMonthDataNames[key] || '';
  }
}
